import {Injectable} from '@angular/core';

@Injectable()
export class WindowService {
  location(url: string) {
    window.location.href = url;
  }

  scrollTo(x: number, y: number) {
    window.scrollTo(x, y);
  }
}
